import { CASES } from '../EnumTypes/ActionEnumTypes';
import { finishCase as finishCaseConnector } from 'Connectors/CaseConnector';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { toast } from 'react-toastify';
import { getCaseDetails } from './';

const init = () => ({
  type: CASES.FINISH_CASE_INIT,
});

const success = () => ({
  type: CASES.FINISH_CASE_SUCCESS,
});

const failure = () => ({
  type: CASES.FINISH_CASE_FAILURE,
});

const finishCase = (caseId) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    await finishCaseConnector(caseId);
    dispatch(success());
    toast.success('Pomyślnie zakończono sprawę');
    dispatch(ViewManagementModule.Actions.hideLoader());
    dispatch(getCaseDetails(caseId));
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    toast.error('Nie udało się zakończyć sprawy');
    dispatch(failure());
  }
};

export default finishCase;
